import httpClient from "./httpClient";

const prefix = "/leader-availabilities";

// Create availability
export const createLeaderAvailability = async (data: any) => {
  return (await httpClient.post(prefix, data)).data;
};

// Get availability by User ID
export const getLeaderAvailabilityByUser = async (userId: number) => {
  return (await httpClient.get(`${prefix}/user/${userId}`)).data;
};

// Update availability
export const updateLeaderAvailability = async (id: number, data: any) => {
  return (await httpClient.patch(`${prefix}/${id}`, data)).data;
};

// Delete availability
export const deleteLeaderAvailability = async (id: number) => {
  return (await httpClient.delete(`${prefix}/${id}`)).data;
};

// --- Interviews ---

export const getLeaders = async () => {
  // Reusing existing user pagination endpoint for leaders (gerentes)
  const response = await httpClient.get(
    `/user/list-paginated?type=gerentes&limit=100`
  );
  return response.data.data;
};

export const createLeaderInterview = async (data: any) => {
  return (await httpClient.post(`/leader-interviews`, data)).data;
};

export const getLeaderInterviews = async (leaderId: number) => {
  return (await httpClient.get(`/leader-interviews/leader/${leaderId}`)).data;
};

export const getLeaderInterviewByApplication = async (
  applicationId: number
) => {
  return (
    await httpClient.get(`/leader-interviews/application/${applicationId}`)
  ).data;
};
